<div class="modal modal_size_744 modal_no-height modal__opened">
  <div class="modal__close icon icon-close" (click)="close()"></div>

  <ng-container *ngIf="showInfoModal; else subscriptionsInfoModal">
    <div class="modal__container">
      <div class="modal__title modal__title-mb24 h2">{{ 'subscriptions-modal-info.subscription-title' | translate }}</div>
      <div class="modal__content">
        <div class="modal__plan">
          <div class="modal-plan__text" *ngIf="privetSubscriptionStatus === 'ACTIVE'">{{ 'subscriptions-modal-info.subscription-privet-text' | translate }}</div>
          <div class="modal-plan__text" *ngIf="privetPlusSubscriptionStatus === 'ACTIVE'">{{ 'subscriptions-modal-info.subscription-privet-pro-text' | translate }}</div>
        </div>
      </div>
    </div>
    <div class="modal__buttons-row modal__buttons-mt40">
      <div class="button" (click)="showInfoModal = false; close()">{{ 'subscriptions-modal-info.button' | translate }}</div>
    </div>
  </ng-container>

  <ng-template #subscriptionsInfoModal>
    <div class="modal__container">

      <div class="info-hint" *ngIf="melody.interval && melody.intervalType"
           [innerHtml]="(melody.serviceType && melody.serviceType === 'PRIVET' ? 'subscriber-melody-settings-modal.price-hint' : 'subscriber-melody-settings-modal.price-hint-privet-plus')
         | translate: {price: melody.price, period: ('subscriber-melody-settings-modal.price-period-' + melody.intervalType.toLowerCase()) | translate : {interval: melody.interval} }"></div>

      <div class="modal__content">
        <div class="song">
          <div class="song__cover">
            <img [src]="melody.pictureUrlSmall" [alt]="melody.title + ', ' + melody.artistTitle"/>
          </div>
          <div class="song__content">
            <div class="song__name">
              <span class="song__name-link">{{ melody.title }}</span>
            </div>
            <div class="song__artist">
              <span class="song__artist-link">{{ melody.artistTitle }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="modal__simple-field modal__simple-field-mb16">
        <label class="switcher__container">
          <div class="switcher__label">{{ 'subscriber-melody-settings-modal.play-for-all' | translate }}</div>
          <div class="switcher__switch">
            <div class="switcher">
              <input type="checkbox" [disabled]="melody.playingForAll && melody.idFromPlatform == -1" class="switcher__input" [(ngModel)]="melody.playingForAll"
                     (ngModelChange)="switchPlayingForAll()"/>
              <div class="switcher__style"></div>
            </div>
          </div>
        </label>
      </div>
      <div class="modal__simple-field" *ngIf="melody.idFromPlatform != -1 && melody.idFromPlatform != -2">
        <span class="link link_type_warning" (click)="removeMelody()">{{ 'subscriber-melody-settings-modal.remove' | translate }}</span>
      </div>
    </div>
  </ng-template>
</div>
